var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 -2.5 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0833 1.8335H8.24992C3.66659 1.8335 1.83325 3.66683 1.83325 8.25016V13.7502C1.83325 18.3335 3.66659 20.1668 8.24992 20.1668H13.7499C18.3333 20.1668 20.1666 18.3335 20.1666 13.7502V11.9168",
    stroke: "#D1D0E1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.7032 2.76832L7.47989 9.99165C7.20489 10.2667 6.92989 10.8075 6.87489 11.2017L6.48072 13.9608C6.33406 14.96 7.03989 15.6567 8.03906 15.5192L10.7982 15.125C11.1832 15.07 11.7241 14.795 12.0082 14.52L19.2316 7.29665C20.4782 6.04999 21.0649 4.60165 19.2316 2.76832C17.3982 0.934987 15.9499 1.52165 14.7032 2.76832Z",
    stroke: "#D1D0E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.6675 3.8042C14.2816 5.99503 15.9958 7.7092 18.1958 8.33253",
    stroke: "#D1D0E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditManagement);
export default __webpack_public_path__ + "static/media/editManagement.8d7ca5d872a2916d4c84bb562803148b.svg";
export { ForwardRef as ReactComponent };